export const CACHE_KEYS = {
  readiness: 'readiness',
  heartRateZones: 'heartRateZones',
  trainingPlan: 'trainingPlan',
  signInFormLastStep: 'signInFormLastStep',
  signInFormData: 'signInFormData',
  collapsableState: 'collapsableState',
  needRedirectToMilesForm: 'needRedirectToMilesForm',
};
